<ion-header>
    <ion-toolbar mode="ios">
        <ion-buttons slot="start" class="pty-header-buttons">
            <ion-button size="large" class="pty-header-button ion-margin-horizontal" (click)="close()">
                <ion-ripple-effect></ion-ripple-effect>
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>
            {{'Bible' | translation}}
        </ion-title>
        <ion-buttons *ngIf="!searchBible" slot="end" (click)="showSearch()">
            <ion-button>
                <ion-icon slot="icon-only" name="search"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons *ngIf="searchBible" slot="end" (click)="showSearch()">
            <ion-button>
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<!-- <ion-content>
    <iframe src="https://www.bible.com/bible/1/GEN.1.KJV "></iframe>
</ion-content> -->
<!--new page-->
<ion-content>
    <ion-row>
        <ion-col [size]="6">
            <ion-item class="inputField" lines="none">
                <ion-select label="{{ 'Language' | translation }}"
                            interface="popover"
                            name="Select Language"
                            class="inputField__area inputField__area--select"
                            (ionChange)="getVolumes($event)" >
        <ion-select-option *ngFor="let lang of LanguageFamily" [value]="lang.language_family_code" >{{lang.language_family_english}}</ion-select-option>
                </ion-select>
            </ion-item>
        </ion-col>
        <ion-col [size]="6">
            <ion-item class="inputField" lines="none">
                <ion-select label="{{ 'Version' | translation }}"
                            interface="popover"
                            name="Select Volume"
                            class="inputField__area inputField__area--select"
                            (ionChange)="getBibleBooks($event)"
                            [value] ="defaultVolume?defaultVolume.dam_id:''"
                            >
                            <ion-select-option *ngFor="let volume of BibleVolumes" [value]="volume.dam_id" >{{volume.volume_name}}</ion-select-option>
                        </ion-select>
            </ion-item>
        </ion-col>
    </ion-row>
    <div class="ion-text-center ion-margin-bottom">
        <ion-button [color]="isOldTestament ? 'primary' : 'secondary'" (click)="showOldTestament()">{{ 'OldTestament' | translation }}</ion-button>
        <ion-button [color]="isNewTestament ? 'primary' : 'secondary'" (click)="showNewTestament()">{{ 'NewTestament' | translation }}</ion-button>
    </div>


    <!--old Testament-->
    <ng-container *ngIf="isOldTestament">
        <div class="accordion-wrapper old-testament-div" *ngFor="let books of OldBibleBooks; let i =index">
            <div class="accordion" (click)="expandItem(i,'old')">
                <div class="accordionHeader" [class.collapsed]="books.isExpanded">
                    <ion-row class="ion-align-items-center">
                        <ion-col size="10">
                            <ion-title class="accordionHeader__heading">{{books.book_name}}</ion-title>
                        </ion-col>
                        <ion-col size="2" class="ion-text-right">
                            <ion-icon name="arrow-dropright"
                                      class="accordionHeader__icon accordionHeader__icon--right"></ion-icon>
                            <ion-icon name="arrow-dropdown"
                                      class="accordionHeader__icon accordionHeader__icon--down"></ion-icon>
                        </ion-col>
                    </ion-row>
                </div>
                <div class="accordionBody" style="padding-bottom: 0;">
                    <app-expandable [expanded]="books.isExpanded">
                        <div  routerDirection="root">
                            <ul class="list-inline bibleVerses">
                                <li *ngFor="let chapters of ' '.repeat(books.number_of_chapters).split(''), let x = index" (click)="navigateToChapter(books.dam_id,books.book_id,x+1)" class="list-inline-item bibleVerses__count active">
                                    {{x+1}}
                                </li>
                            </ul>
                        </div>
                    </app-expandable>
                </div>
            </div>
        </div>
    </ng-container>
    <!--New Testament-->
    <ng-container *ngIf="isNewTestament">
    <div class="accordion-wrapper old-testament-div" *ngFor="let books of BibleBooks; let i =index">
        <div class="accordion" (click)="expandItem(i,'new')">
            <div class="accordionHeader" [class.collapsed]="books.isExpanded">
                <ion-row class="ion-align-items-center">
                    <ion-col size="10">
                        <ion-title class="accordionHeader__heading">{{books.book_name}}</ion-title>
                    </ion-col>
                    <ion-col size="2" class="ion-text-right">
                        <ion-icon name="arrow-dropright"
                                  class="accordionHeader__icon accordionHeader__icon--right"></ion-icon>
                        <ion-icon name="arrow-dropdown"
                                  class="accordionHeader__icon accordionHeader__icon--down"></ion-icon>
                    </ion-col>
                </ion-row>
            </div>
            <div class="accordionBody" style="padding-bottom: 0;">
                <app-expandable [expanded]="books.isExpanded">
                    <div  routerDirection="root">
                        <ul class="list-inline bibleVerses">
                            <li *ngFor="let chapters of ' '.repeat(books.number_of_chapters).split(''), let x = index" (click)="navigateToChapter(books.dam_id,books.book_id,x+1)" class="list-inline-item bibleVerses__count active">
                                {{x+1}}
                            </li>
                        </ul>
                    </div>
                </app-expandable>
            </div>
        </div>
    </div>
</ng-container>
</ion-content>

<!--old page-->

<ion-content class="ion-no-padding" *ngIf="!searchBible" style="display: none;">
    <ion-item class=ion-no-border style="border-bottom: 1px solid #ccc;" *ngIf="versionSet === 'active'">
        <label slot="start">{{ 'SwitchBibleVersion' | translation }}</label>
        <ion-button slot="end" (click)="configureBibleVersion()">{{ 'Switch' | translation }}</ion-button>
    </ion-item>
    <ion-list lines="none">
        <div *ngIf="versionSet === 'inactive'">
            <ion-item class="selw75">
                <h2 class="ion-text-wrap" style="font-weight: bold; text-align: center;">{{ 'ConfigureBibleVersion' | translation }}</h2>
            </ion-item>
            <ion-button expand="block" (click)="configureBibleVersion()">{{ 'LetConfigure' | translation }}</ion-button>
        </div>

        <div *ngIf="versionSet === 'active'">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-item>
                            <ion-select label="{{ 'SelectBook' | translation }}" label-placement="floating" placeholder="{{ 'SelectBook' | translation }}" (ionChange)="bookSelected($event)">
                                <ion-select-option *ngFor="let item of books" [value]="item.id">{{item.name}}
                                </ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                    <ion-col>
                        <ion-item>
                            <ion-select label="{{ 'SelectChapter' | translation }}" label-placement="floating" placeholder="{{ 'SelectChapter' | translation }}" (ionChange)="chapterSelected($event)">
                                <ion-select-option *ngFor="let item of chapters" [value]="item.id">{{item.number}}
                                </ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <ul class="chapterContent__ul" *ngIf="versesWithContent">
                <li class="chapterContent__li" *ngFor="let row of versesWithContent">
                    {{row?.content}}
                </li>
            </ul>
        </div>
    </ion-list>
</ion-content>

<ion-content class="ion-no-padding" *ngIf="searchBible">
    <ion-list lines="none">
        <ion-item>
            <ion-searchbar showCancelButton="always" (ionChange)="searchBibleItems($event)"></ion-searchbar>
        </ion-item>

        
        <div class="accordion-wrapper old-testament-div" *ngFor="let books of SearchBooks; let i =index">
            <div class="accordion" (click)="expandItemGeneral(i)">
                <div class="accordionHeader" [class.collapsed]="books.isExpand">
                    <ion-row class="ion-align-items-center">
                        <ion-col size="10">
                            <div style="display: flex;">
                            <i class="fas fa-bible"></i>
                            <ion-title class="accordionHeader__heading">{{books.book_name}}</ion-title>
                            </div>
                        </ion-col>
                        <ion-col size="2" class="ion-text-right">
                            <ion-icon name="arrow-dropright"
                                      class="accordionHeader__icon accordionHeader__icon--right"></ion-icon>
                            <ion-icon name="arrow-dropdown"
                                      class="accordionHeader__icon accordionHeader__icon--down"></ion-icon>
                        </ion-col>
                    </ion-row>
                </div>
                <div class="accordionBody" style="padding-bottom: 0;">
                    <app-expandable [expanded]="books.isExpand">
                        <div  routerDirection="root">
                            <ul class="list-inline bibleVerses">
                                <li *ngFor="let chapters of ' '.repeat(books.number_of_chapters).split(''), let x = index" (click)="navigateToChapter(books.dam_id,books.book_id,x+1)" class="list-inline-item bibleVerses__count active">
                                    {{x+1}}
                                </li>
                            </ul>
                        </div>
                    </app-expandable>
                </div>
            </div>
        </div>




        <ion-item>
            <ul class="chapterContent__ul" *ngIf="searchVersesWithContent">
                <li class="chapterContent__li" *ngFor="let row of searchVersesWithContent" (click)="shareVerse(row)">
                    <span style="font-weight: bold;">REF:{{ row?.book_name}}</span> - {{row?.verse_text}}
                </li>
            </ul>
            <p *ngIf="!searchVersesWithContent">{{ 'LangAndVersionRequired' | translation }}</p>
        </ion-item>
    </ion-list>
</ion-content>
